import React from "react";

function ListingMapTab({ mapDesc }) {
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-[#F1F5F9] overflow-hidden shadow-2xs">
        <div className="relative h-[210px] w-full bg-[#EBF2EA] overflow-hidden">
          <svg
            className="w-full h-full object-cover"
            viewBox="0 0 400 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="400" height="220" fill="#E4EFE0" />

            <path
              d="M 0,0 L 400,0 L 400,90 C 320,80 280,120 200,95 C 140,75 80,110 0,90 Z"
              fill="#EAE5D8"
              opacity="0.85"
            />
            <path d="M 50,20 L 160,20 L 150,70 L 40,65 Z" fill="#DCD5C4" />
            <path d="M 180,15 L 320,15 L 300,60 L 190,55 Z" fill="#DCD5C4" />
            <path
              d="M 0,165 C 60,155 120,175 190,160 C 260,145 310,180 400,165 L 400,220 L 0,220 Z"
              fill="#BFDFEE"
            />
            <path
              d="M 90,170 C 140,162 210,180 270,168 C 330,158 370,185 400,180 L 400,220 L 90,220 Z"
              fill="#A4D1E8"
              opacity="0.8"
            />
            <path
              d="M -10,130 C 80,120 160,145 240,130 C 310,118 360,140 420,125"
              stroke="#FFFFFF"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <path
              d="M -10,130 C 80,120 160,145 240,130 C 310,118 360,140 420,125"
              stroke="#FED085"
              strokeWidth="4"
              strokeLinecap="round"
            />

            <path d="M 100,10 L 120,130 L 140,180" stroke="#FFFFFF" strokeWidth="4" />
            <path d="M 230,10 L 220,130 L 210,190" stroke="#FFFFFF" strokeWidth="4" />
            <path d="M 40,80 L 370,70" stroke="#FFFFFF" strokeWidth="3" />

            <circle cx="95" cy="85" r="4" fill="#E67E22" />
            <text x="105" y="88" fill="#D35400" fontSize="8" fontWeight="bold">
              Intermarché
            </text>

            <circle cx="215" cy="75" r="4" fill="#E67E22" />
            <text x="225" y="78" fill="#D35400" fontSize="8" fontWeight="bold">
              Lidl
            </text>

            <text x="145" y="195" fill="#2980B9" fontSize="8" fontWeight="600">
              Marina de Lagos
            </text>
            <circle cx="230" cy="192" r="3" fill="#2980B9" />

            <text
              x="200"
              y="125"
              fill="#2C3E50"
              fontSize="18"
              fontWeight="800"
              letterSpacing="0.5"
              textAnchor="middle"
              opacity="0.75"
            >
              Lagos
            </text>
            <path
              d="M 112,118 L 98,75 A 35 35 0 0 1 126,75 Z"
              fill="#3498DB"
              opacity="0.25"
            />
            <circle cx="112" cy="118" r="16" fill="#3498DB" opacity="0.15" />
            <circle cx="112" cy="118" r="9" fill="#0088FF" stroke="#FFFFFF" strokeWidth="2.5" />
            <circle cx="112" cy="118" r="4" fill="#FFFFFF" />
          </svg>
        </div>
        <div className="p-4">
          <p className="text-[#4A5568] font-[400] text-[12px] leading-relaxed">
            {mapDesc}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ListingMapTab;
